import { Badge, Card, Modal, COMM_CATEGORIES, COMM_CATEGORY_COLOR, COMM_PRIORITY_COLOR, COMM_PRIORITY_LABEL, btnPrimary, btnSecondary, btnDanger, inputStyle, labelStyle } from "./shared";

export default function Communications({
  communications, tenants,
  can,
  commSearch, setCommSearch,
  commCatFilter, setCommCatFilter,
  commPriFilter, setCommPriFilter,
  commTenantFilter, setCommTenantFilter,
  commDateFrom, setCommDateFrom,
  commDateTo, setCommDateTo,
  showAddComm, setShowAddComm,
  newComm, setNewComm, addComm,
  showCommLog, setShowCommLog,
  deleteComm,
}) {
  const anyFilter = commSearch || commCatFilter || commPriFilter || commTenantFilter || commDateFrom || commDateTo;
  const clearFilters = () => { setCommSearch(""); setCommCatFilter(""); setCommPriFilter(""); setCommTenantFilter(""); setCommDateFrom(""); setCommDateTo(""); };
  const filtered = communications.filter(c => {
    const matchSearch = !commSearch || c.subject?.toLowerCase().includes(commSearch.toLowerCase()) || c.body?.toLowerCase().includes(commSearch.toLowerCase()) || c.tenant?.toLowerCase().includes(commSearch.toLowerCase()) || c.logged_by?.toLowerCase().includes(commSearch.toLowerCase());
    const matchCat    = !commCatFilter || c.type === commCatFilter;
    const matchPri    = !commPriFilter || c.priority === commPriFilter;
    const matchTenant = !commTenantFilter || c.tenant === commTenantFilter;
    const entryDate   = c.date || (c.created_at ? c.created_at.slice(0, 10) : null);
    const matchFrom   = !commDateFrom || (entryDate && entryDate >= commDateFrom);
    const matchTo     = !commDateTo   || (entryDate && entryDate <= commDateTo);
    return matchSearch && matchCat && matchPri && matchTenant && matchFrom && matchTo;
  });
  const uniqueTenants = [...new Set(communications.map(c => c.tenant).filter(Boolean))].sort();

  return (
    <>
      <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div>
          <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 32, color: "#2B2B2B", margin: 0 }}>Communications</h1>
          <div style={{ color: "#9B9690", marginTop: 4, fontSize: 14 }}>All tenant interactions — calls, texts, emails, and notes</div>
        </div>
        {can.addComm && <button onClick={() => setShowAddComm(true)} style={btnPrimary}>+ Log Interaction</button>}
      </div>

      <div className="app-metric-row" style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 24 }}>
        {[
          { label: "Total Logs",        value: communications.length,                                                                                                                                        color: "#163C2F" },
          { label: "Urgent",             value: communications.filter(c => c.priority === "urgent").length,                                                                                                  color: "#ef4444" },
          { label: "This Month",         value: communications.filter(c => { const d = new Date(c.created_at || c.date); const n = new Date(); return d.getMonth() === n.getMonth() && d.getFullYear() === n.getFullYear(); }).length, color: "#3b82f6" },
          { label: "Tenants Contacted",  value: new Set(communications.map(c => c.tenant).filter(Boolean)).size,                                                                                             color: "#f59e0b" },
        ].map(s => (
          <Card key={s.label} style={{ padding: 16, textAlign: "center" }}>
            <div style={{ fontSize: 26, fontWeight: 800, color: s.color, fontFamily: "'Cormorant Garamond', serif" }}>{s.value}</div>
            <div style={{ fontSize: 11, color: "#9B9690", marginTop: 2, textTransform: "uppercase", letterSpacing: "0.06em" }}>{s.label}</div>
          </Card>
        ))}
      </div>

      <Card style={{ padding: "16px 20px", marginBottom: 20 }}>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
          <div style={{ flex: "1 1 200px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Search</div>
            <input type="text" placeholder="Subject, notes, tenant, logged by…" value={commSearch} onChange={e => setCommSearch(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: "1 1 140px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Tenant</div>
            <select value={commTenantFilter} onChange={e => setCommTenantFilter(e.target.value)} style={inputStyle}>
              <option value="">All Tenants</option>
              {uniqueTenants.map(t => <option key={t} value={t}>{t}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 140px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Category</div>
            <select value={commCatFilter} onChange={e => setCommCatFilter(e.target.value)} style={inputStyle}>
              <option value="">All Categories</option>
              {COMM_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div style={{ flex: "1 1 130px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Priority</div>
            <select value={commPriFilter} onChange={e => setCommPriFilter(e.target.value)} style={inputStyle}>
              <option value="">All Priorities</option>
              <option value="urgent">🔴 Urgent</option>
              <option value="normal">⚪ Normal</option>
              <option value="informational">🔵 Informational</option>
            </select>
          </div>
          <div style={{ flex: "1 1 120px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Date From</div>
            <input type="date" value={commDateFrom} onChange={e => setCommDateFrom(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: "1 1 120px" }}>
            <div style={{ ...labelStyle, marginBottom: 4 }}>Date To</div>
            <input type="date" value={commDateTo} onChange={e => setCommDateTo(e.target.value)} style={inputStyle} />
          </div>
          {anyFilter && (
            <button onClick={clearFilters} style={{ ...btnSecondary, fontSize: 12, alignSelf: "flex-end" }}>Clear</button>
          )}
        </div>
        {anyFilter && (
          <div style={{ marginTop: 10, fontSize: 12, color: "#9B9690" }}>
            Showing <strong style={{ color: "#163C2F" }}>{filtered.length}</strong> of {communications.length} entries
          </div>
        )}
      </Card>

      {filtered.length === 0 ? (
        <Card style={{ textAlign: "center", padding: 48, color: "#9B9690" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>💬</div>
          <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 18, color: "#163C2F", marginBottom: 6 }}>No interactions found</div>
          <div style={{ fontSize: 13 }}>{communications.length === 0 ? "Start logging calls, texts, and notes with your tenants." : "Try adjusting your filters."}</div>
        </Card>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {filtered.map(c => {
            const displayDate = c.date || (c.created_at ? new Date(c.created_at).toLocaleDateString() : "");
            const displayTime = c.created_at ? new Date(c.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : null;
            return (
              <Card key={c.id} style={{ padding: "14px 18px", borderLeft: c.priority === "urgent" ? "4px solid #ef4444" : c.priority === "informational" ? "4px solid #3b82f6" : "4px solid #e0dbd0" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12 }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: "flex", gap: 6, marginBottom: 6, flexWrap: "wrap", alignItems: "center" }}>
                      <Badge label={c.type || "Note"} color={COMM_CATEGORY_COLOR[c.type] || "#6b7280"} />
                      {c.priority && <Badge label={COMM_PRIORITY_LABEL[c.priority] || c.priority} color={COMM_PRIORITY_COLOR[c.priority] || "#6b7280"} />}
                    </div>
                    <div style={{ fontWeight: 700, fontSize: 14, color: "#163C2F", marginBottom: c.body ? 6 : 0 }}>{c.subject}</div>
                    {c.body && <div style={{ fontSize: 13, color: "#2B2B2B", whiteSpace: "pre-wrap", marginBottom: 8, lineHeight: 1.6 }}>{c.body}</div>}
                    <div style={{ fontSize: 11, color: "#9B9690", display: "flex", gap: 12, flexWrap: "wrap", alignItems: "center" }}>
                      <span style={{ fontWeight: 600, color: "#2B2B2B" }}>👤 {c.tenant || "—"}</span>
                      <span>📅 {displayDate}</span>
                      {displayTime && <span>🕐 {displayTime}</span>}
                      {c.logged_by && <span style={{ borderLeft: "1px solid #d4cfc4", paddingLeft: 12 }}>Logged by <strong style={{ color: "#2B2B2B" }}>{c.logged_by}</strong></span>}
                    </div>
                  </div>
                  {can.deleteComm && (
                    <button onClick={() => deleteComm(c.id)} style={{ ...btnDanger, flexShrink: 0, alignSelf: "flex-start", fontSize: 12, padding: "5px 10px" }}>Delete</button>
                  )}
                </div>
              </Card>
            );
          })}
        </div>
      )}

      {/* Communication Log Modal */}
      {showCommLog && (
        <Modal title={`Comm Log — ${showCommLog.name}`} onClose={() => setShowCommLog(null)}>
          {can.addComm && (
            <button style={btnPrimary} onClick={() => { setNewComm(s => ({ ...s, tenant: showCommLog.name })); setShowAddComm(true); }}>+ Log Interaction</button>
          )}
          {communications.filter(c => c.tenant === showCommLog.name).length === 0 ? (
            <div style={{ color: "#9B9690", fontSize: 13, textAlign: "center", padding: "20px 0" }}>No interactions logged yet.</div>
          ) : (
            communications.filter(c => c.tenant === showCommLog.name).map(c => {
              const displayDate = c.date || (c.created_at ? new Date(c.created_at).toLocaleDateString() : "");
              const displayTime = c.created_at ? new Date(c.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : null;
              return (
                <div key={c.id} style={{ padding: "12px 14px", background: "#F5F1EA", borderRadius: 10, borderLeft: c.priority === "urgent" ? "3px solid #ef4444" : c.priority === "informational" ? "3px solid #3b82f6" : "3px solid #d4cfc4" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 6 }}>
                    <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                      <Badge label={c.type || "Note"} color={COMM_CATEGORY_COLOR[c.type] || "#6b7280"} />
                      {c.priority && <Badge label={COMM_PRIORITY_LABEL[c.priority] || c.priority} color={COMM_PRIORITY_COLOR[c.priority] || "#6b7280"} />}
                    </div>
                    {can.deleteComm && <button onClick={() => deleteComm(c.id)} style={{ ...btnDanger, padding: "2px 8px", fontSize: 11, flexShrink: 0 }}>✕</button>}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: "#163C2F", marginBottom: c.body ? 4 : 0 }}>{c.subject}</div>
                  {c.body && <div style={{ fontSize: 13, color: "#2B2B2B", whiteSpace: "pre-wrap", marginBottom: 6, lineHeight: 1.5 }}>{c.body}</div>}
                  <div style={{ fontSize: 11, color: "#9B9690", display: "flex", gap: 10, flexWrap: "wrap", marginTop: 4 }}>
                    <span>📅 {displayDate}</span>
                    {displayTime && <span>🕐 {displayTime}</span>}
                    {c.logged_by && <span style={{ borderLeft: "1px solid #c4c0b8", paddingLeft: 10 }}>by <strong style={{ color: "#9B9690" }}>{c.logged_by}</strong></span>}
                  </div>
                </div>
              );
            })
          )}
        </Modal>
      )}

      {/* Add Communication Modal */}
      {showAddComm && (
        <Modal title="Log Interaction" onClose={() => { setShowAddComm(false); setNewComm({ tenant: "", type: "Phone Call", subject: "", body: "", date: new Date().toISOString().slice(0,10), priority: "normal" }); }} onSave={addComm}>
          <div>
            <label style={labelStyle}>Tenant</label>
            <select value={newComm.tenant} onChange={e => setNewComm(s => ({ ...s, tenant: e.target.value }))} style={inputStyle}>
              <option value="">— Select Tenant —</option>
              {tenants.map(t => <option key={t.name} value={t.name}>{t.name}</option>)}
            </select>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div>
              <label style={labelStyle}>Category</label>
              <select value={newComm.type} onChange={e => setNewComm(s => ({ ...s, type: e.target.value }))} style={inputStyle}>
                {COMM_CATEGORIES.map(c => <option key={c}>{c}</option>)}
              </select>
            </div>
            <div>
              <label style={labelStyle}>Priority</label>
              <select value={newComm.priority} onChange={e => setNewComm(s => ({ ...s, priority: e.target.value }))} style={inputStyle}>
                <option value="urgent">🔴 Urgent</option>
                <option value="normal">⚪ Normal</option>
                <option value="informational">🔵 Informational</option>
              </select>
            </div>
          </div>
          <div>
            <label style={labelStyle}>Date</label>
            <input type="date" value={newComm.date} onChange={e => setNewComm(s => ({ ...s, date: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Subject</label>
            <input type="text" value={newComm.subject} onChange={e => setNewComm(s => ({ ...s, subject: e.target.value }))} style={inputStyle} placeholder="e.g. Called about late payment" />
          </div>
          <div>
            <label style={labelStyle}>Notes</label>
            <textarea value={newComm.body} onChange={e => setNewComm(s => ({ ...s, body: e.target.value }))} style={{ ...inputStyle, height: 100, resize: "vertical" }} placeholder="Details of the conversation..." />
          </div>
        </Modal>
      )}
    </>
  );
}
